const FileInput = function () {
    var $input = $("<input/>").attr({
        type: "file"
    });

    this.select = (accept) => {
        // hacking around to detect user cancel
        // File System Access API shall make things easier some day
        return new Promise((resolve) => {
            if (accept !== undefined) {
                $input.attr("accept", accept);
            }
            var cancel_timeout = null;
            $input.on("change", () => {
                if (cancel_timeout !== null) {
                    window.clearTimeout(cancel_timeout);
                }
                resolve($input[0].files[0]);
                $input.off("change");
                window.document.body.onfocus = null;

            });
            window.document.body.onfocus = () => {
                window.document.body.onfocus = null;
                cancel_timeout = window.setTimeout(() => {
                    $input.off("change");
                    if ($input[0].files.length === 0) {
                        resolve(null);
                    }
                }, 500);
            };
            $input.trigger("click");
        });
    };

    this.reset = () => {
        $input.removeAttr("accept");
        $input.val("");
    };

};

export default FileInput;
